import { NumberOfGuests } from 'components/NumberOfGuests/NumberOfGuests';
import { NumberOfGuestsProps } from 'components/NumberOfGuests/types';
import { AppProvider } from 'contexts/appContext';
import { BrandCode, Locale } from 'lib/config/config';
import { themes } from 'theme/themes';

interface WrapperProps extends NumberOfGuestsProps {
	brandCode: BrandCode;
	locale: Locale;
}

export const Wrapper: React.FC<WrapperProps> = (props) => {
	const theme = themes[props.brandCode];

	return (
		<AppProvider locale={props.locale} brandCode={props.brandCode}>
			<div className={theme}>
				<NumberOfGuests {...props} />
			</div>
		</AppProvider>
	);
};
